import HeaderBar from "../../components/HeaderBar";
import { useState, useContext } from "react";
import getCurrentSkin from "../../utils/getCurrentSkin";
import { ThemeContext } from "../../context/ThemeContext";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import VehicleLayoutWrapper from "../../components/VehicleLayoutWrapper";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft, FaSave, FaPlus } from "react-icons/fa";

const EquipmentVehicleType = () => {
  const { isDark, skin, setSkin } = useContext(ThemeContext);
  const currentSkin = getCurrentSkin(skin);
  const { baseColor, baseShade } = currentSkin;
  const buttonClass = `bg-${baseColor}-${baseShade}`;
  const hoverClass = `hover:bg-${baseColor}-700`;
  const navigate = useNavigate();

  const [vehicleMainType, setVehicleMainType] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    if (!vehicleMainType.trim()) {
      toast.error("Please enter a vehicle main type!");
      return;
    }

    setLoading(true);
    try {
      // Replace with your actual API endpoint
      await axios.post("http://nissi-india.com/api/vehicleMainType", {
        vehicleMainType: vehicleMainType.trim(),
      });

      toast.success("Vehicle Main Type saved successfully!");
      setVehicleMainType(""); // Clear form after successful save
    } catch (error) {
      console.error("Error saving vehicle main type:", error);
      toast.error("Failed to save vehicle main type!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <VehicleLayoutWrapper>
      <HeaderBar
        title={
          <span className="font-dmserif text-3xl">
            EQUIPMENT VEHICLE TYPE 
          </span>
        }
        setSkin={setSkin}
        currentSkin={skin}
      />

      <div
        className={`p-6 mt-6 rounded-2xl shadow-xl border ${
          isDark
            ? "bg-gradient-to-br from-white/20 to-white/5 backdrop-blur-md border-white/10 text-white"
            : `bg-white ${currentSkin.glass} text-black`
        }`}
      >
        {/* Header Section */}
        <div className="flex justify-between items-center mb-8">
          <div className="flex items-center gap-4">
            <h1 className={`text-2xl font-bold ${
              isDark ? "text-white" : "text-gray-900"
            }`}>
              Add Vehicle Type
            </h1>
          </div>
          
          <button
            onClick={() => navigate(-1)}
            className={`flex items-center gap-2 px-4 py-2 border rounded-lg transition-colors ${
              isDark
                ? "border-gray-600 text-white hover:bg-gray-800"
                : "border-gray-300 text-gray-700 hover:bg-gray-50"
            }`}
          >
            <FaArrowLeft className="w-4 h-4" />
            Back to Listing
          </button>
        </div>

        {/* Form Container */}
        <div className={`rounded-xl p-6 border ${
          isDark 
            ? "bg-gray-800 border-gray-700" 
            : "bg-gray-50 border-gray-200"
        }`}>
          <div className="max-w-2xl mx-auto">
            {/* Input field */}
            <div className="mb-8">
              <label
                htmlFor="vehicleMainType"
                className={`block text-sm font-medium mb-2 ${
                  isDark ? "text-gray-300" : "text-gray-700"
                }`}
              >
                Vehicle  Type
              </label>
              <input
                id="vehicleMainType"
                type="text"
                value={vehicleMainType}
                onChange={(e) => setVehicleMainType(e.target.value)}
                placeholder="Enter vehicle main type..."
                className={`w-full px-4 py-3 rounded-lg border focus:ring-2 focus:ring-blue-500 focus:border-transparent transition ${
                  isDark
                    ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400"
                    : "bg-white border-gray-300 text-gray-900 placeholder-gray-500"
                }`}
              />
            </div>

            {/* Action Buttons */}
            <div className="flex justify-end gap-4 pt-4 border-t border-gray-200 dark:border-gray-700">
              <button
                onClick={() => setVehicleMainType("")}
                className="px-6 py-3 text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-600 rounded-lg font-medium hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
              >
                Clear
              </button>
              <button
                onClick={handleSave}
                disabled={loading || !vehicleMainType.trim()}
                className={`flex items-center gap-2 px-8 py-3 text-white rounded-lg font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 ${
                  loading || !vehicleMainType.trim()
                    ? "bg-gray-400 cursor-not-allowed"
                    : `${buttonClass} ${hoverClass}`
                }`}
              >
                {loading ? (
                  <>
                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                    Saving...
                  </>
                ) : (
                  <>
                    <FaSave className="w-4 h-4" />
                    Save Vehicle Type
                  </>
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Toast Notifications */}
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          closeOnClick
          pauseOnHover
          theme={isDark ? "dark" : "light"}
        />
      </div>
    </VehicleLayoutWrapper>
  );
};

export default EquipmentVehicleType;